module.exports = __webpack_public_path__ + "static/media/rocket.6e14d99e.svg";